<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>G.H. Raisoni Memorial Durg Divisional One Day Rapid Chess Tournament 2026, Durg </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>G.H. Raisoni Memorial Durg Divisional One Day Rapid Chess Tournament 2026, Durg </span></h2>
        </div>
        <p><strong> Name: </strong>G.H. Raisoni Memorial Durg Divisional One Day Rapid Chess Tournament 2026, Durg</p>
        <p><strong> Date: </strong>23rd May 2026</p>
        <p><strong> Venue: </strong>Shri Jalaram Sanskritik Bhawan, Civil Lines, Durg.</p>
        <p><strong> Organized By: </strong>Jila Shatranj Sangh Durg (DCAD)</p>
        <p><strong> In Association With: </strong>G.H. Raisoni Sports and Cultural
            Foundation and the Kalpana Prakash Welfare Foundation</p>
        <p><strong> Under The Aegis of: </strong>Chhattisgarh
            State Chess Association (CGSCA)</p>
        <p><strong> Total Participation: </strong>168 Players</p>
        <h5 class="primary-purple">Event Overview:</h5>
        <p>The G.H. Raisoni Memorial Durg Divisional Chess Tournament 2026, Durg was successfully conducted on
            23rd May 2026 at the elegant Shri Jalaram Sanskritik Bhawan, Civil Lines, Durg. The championship was
            organized by the Jila Shatranj Sangh Durg (DCAD) in association with the G.H. Raisoni Sports and Cultural
            Foundation and the Kalpana Prakash Welfare Foundation. Held under the official aegis of the Chhattisgarh
            State Chess Association (CGSCA), this competitive one-day rapid tournament was restricted exclusively to
            players belonging to the Durg Division.</p>
        <p>The tournament comprehensively drew participants from all 7 districts comprising the division: Balod,
            Bemetara,
            Durg, Kabirdham (Kawardha), Khairagarh-Chhuikhadan-Gandai, Mohla-Manpur-Ambagarh Chowki, and
            Rajnandgaon. In order to honor the standard of competition and celebrate each player's athletic dedication,
            all 168
            participants were awarded an official commemorative Medal and a digital Merit/Participation E-Certificate
            following the conclusion of the event.</p>

        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Tournament Report</h4>
                            </div>
                        </div>

                    </div>
                    <iframe
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghr-raisoni-tournament-report-26.pdf"
                        width="100% " height="500px" frameborder="0"></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
